import React from 'react';
import HomeRateChartDesktop from '../../../assets/images/home-rate-chart-desktop.svg';
import HomeRateChartMobile from '../../../assets/images/home-rate-chart-mobile.svg';
import HomeRateChartMobileHeader from '../../../assets/images/home-rate-chart-mobile-header.svg';

const HomepageRateChart = () => {
  return (
    <section className="homepage-rate-chart">
      <div className="container">
        <div className="homepage-rate-chart-title">
          <h2>Switching to EVs can save you a bundle.</h2>
          <p>
            How much you save depends on your rate and programs you're enrolled
            in. Explore options that match your schedule and lifestyle.
          </p>
          <a className="btn btn-national" role="button" href="/rates">
            Find the best rate
          </a>
        </div>
        <div className="homepage-rate-chart-container">
          <div className="rate-chart-title">
            <h1>
              Annual Estimated Electricity and Vehicle Fuel Cost Comparison
            </h1>
          </div>
          <h2>
            You can save <strong>~$675</strong> per year by switching to{' '}
            <strong>EV Charge Smart Plan with SC-1</strong> with a Mustang Match
            E GT Extended Range AWD. These savings come from both fuel cost
            savings vs. gasoline and from a National grid EV program or VTOU
            rate.
          </h2>
          <img
            src={HomeRateChartDesktop}
            className="rate-chart-desktop"
            alt="Rate Chart"
          />
          <img
            src={HomeRateChartMobileHeader}
            className="rate-chart-mobile header"
            alt="Rate Chart Header"
          />
          <img
            src={HomeRateChartMobile}
            className="rate-chart-mobile"
            alt="Rate Chart"
          />
        </div>
      </div>
    </section>
  );
};

export default HomepageRateChart;
